<style lang="scss">
.mobile-search-overlay {
    position: fixed;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100); //vh fix from app.js
    z-index: 5000;
    top: 0;
    left: 0;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0s 0.2s;

    &.active {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }

    .hamburger-button {
        padding: 24px 14px !important;
    }

    .link-white {
        text-decoration: none !important;
        transition: color 0.15s;

        &:hover {
            color: #f39225 !important;
        }
    }

    .search {
        margin: 0 !important;
        display: block !important;
    }

    .header-search {
        &:before {
            content: url("/svg/search-small-white.svg");
        }

        input {
            border-color: rgba(255, 255, 255, 0.3);
            color: #fff !important;

            &:focus {
                border-color: #fff;
            }
        }

        .search-submit {
            .arrow-right-small {
                content: url("/svg/arrow-right-small-white.svg");
            }
        }
    }
}
</style>

<template>
    <div class="mobile-search-overlay bg-dark" :class="{'active': $root.mobileSearchIsVisible}">
        <div class="mobile-search-overlay-inner h-100 d-lg-flex flex-column justify-content-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    updated() {
        if (this.$root.mobileSearchIsVisible) {
            document.getElementById("mobile-search").focus();
        } else {
            let scrollTop = document.scrollingElement.scrollTop
;
            let body = document.body;

            let tmp = document.createElement('input');
            tmp.style.opacity = 0;
            body.appendChild(tmp);
            tmp.focus();
            body.removeChild(tmp);
            document.scrollingElement.scrollTop = scrollTop;
        }
    }
}
</script>